export interface Product {
    id: number;
    name: string;
    category: string;
    price: number;
    icon: string;
    tint: string;
}

export const PRODUCTS: Product[] = [
    { id: 1, name: "Wireless Headphones", category: "Audio", price: 89.99, icon: "🎧", tint: "#ede9fe" },
    { id: 2, name: "Mechanical Keyboard", category: "Accessories", price: 129.0, icon: "⌨️", tint: "#e0f2fe" },
    { id: 3, name: "Ergonomic Mouse", category: "Accessories", price: 49.5, icon: "🖱️", tint: "#dcfce7" },
    { id: 4, name: "4K Monitor 27\"", category: "Displays", price: 349.0, icon: "🖥️", tint: "#fef3c7" },
    { id: 5, name: "Smart Watch", category: "Wearables", price: 199.0, icon: "⌚", tint: "#fce7f3" },
    { id: 6, name: "Bluetooth Speaker", category: "Audio", price: 59.9, icon: "🔊", tint: "#ede9fe" },
    { id: 7, name: "HD Webcam", category: "Accessories", price: 69.0, icon: "📷", tint: "#e0f2fe" },
    { id: 8, name: "Laptop Stand", category: "Accessories", price: 34.99, icon: "💻", tint: "#dcfce7" },
    { id: 9, name: "USB-C Hub", category: "Accessories", price: 39.0, icon: "🔌", tint: "#fef3c7" },
    { id: 10, name: "Fitness Band", category: "Wearables", price: 45.0, icon: "📿", tint: "#fce7f3" },
];

export const PROMO_CODES: Record<string, number> = {
    SMART10: 0.1,
    WELCOME20: 0.2,
};

export const FREE_SHIPPING_FROM = 150;
export const SHIPPING_COST = 7.99;
export const VAT_RATE = 0.19;
